export enum ClaimStates {
	WaitingForReview = 'WaitingForReview',
	Approved = 'Approved',
	RequestedAdditionalInfo = 'RequestedAdditionalInfo',
	Rejected = 'Rejected',
	PaymentInfoRequested = 'PaymentInfoRequested',
	PaymentInfoReceived = 'PaymentInfoReceived',
	Paid = 'Paid',
}
